import { render, staticRenderFns } from "./GanttRowPeriod.vue?vue&type=template&id=1a6c137c&scoped=true"
import script from "./GanttRowPeriod.vue?vue&type=script&lang=js"
export * from "./GanttRowPeriod.vue?vue&type=script&lang=js"
import style0 from "./GanttRowPeriod.vue?vue&type=style&index=0&id=1a6c137c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c137c",
  null
  
)

export default component.exports